import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthenticationRoutingModule } from './authentication-routing.module';

import { AuthenticationComponent } from './authentication/authentication.component'
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { EmailConfirmationComponent } from './email-confirmation/email-confirmation.component';
import { ForgotpasswordConfirmationComponent } from './forgotpassword-confirmation/forgotpassword-confirmation.component';
import { ResendemailConfirmationComponent } from './resendemail-confirmation/resendemail-confirmation.component';
import { SignupConfirmationComponent } from './signup-confirmation/signup-confirmation.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { LoginWayComponent } from './login-way/login-way.component';

@NgModule({
  declarations: [
    AuthenticationComponent,
    LoginComponent,
    SignupComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    EmailConfirmationComponent,
    ForgotpasswordConfirmationComponent,
    ResendemailConfirmationComponent,
    SignupConfirmationComponent,
    LoginWayComponent
  ],

  imports: [
    CommonModule,
    AuthenticationRoutingModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatAutocompleteModule,
    MatSelectModule,
    MatCheckboxModule,
    AutocompleteLibModule,
  ]
})
export class AuthenticationModule { }
